module.exports = __webpack_public_path__ + "static/media/frontend-frameworks-optimized.7cb944a2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/slides/04-what-is-react/images/frontend-frameworks-optimized.jpg
// module id = 936
// module chunks = 0